'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

exports.default = isHotReloading;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/util/isHotReloading.js
// module id = 3105
// module chunks = 0